import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  useTheme,
} from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import { useRootStore } from 'hooks/useRootStore';
import interfaceBridge from 'utils/interfaceBridge';
import ThemeManager from 'utils/ThemeManager';

type AccountMenuPropsT = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
};

function AccountMenu({ anchorEl, open, onClose, onLogout }: AccountMenuPropsT) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem onClick={onLogout}>
        <ListItemText>로그아웃</ListItemText>
      </MenuItem>
    </Menu>
  );
}

const NavbarPersonal = observer(() => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { userStore } = useRootStore();
  const isDarkMode = theme.palette.mode === 'dark';
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState<HTMLElement | null>(null);
  const accountMenuOpen = Boolean(accountMenuAnchorEl);

  const logout = () => {
    console.log('logout');
    interfaceBridge.goToSignIn();
  };

  const goToSetting = () => {
    navigate('/teacherSide/setting/attendance');
  };

  const toggleTheme = () => {
    ThemeManager.setTheme(isDarkMode ? 'light' : 'dark');
  };

  const openAccountMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAccountMenuAnchorEl(event.currentTarget);
  };

  const closeAccountMenu = () => {
    setAccountMenuAnchorEl(null);
  };

  const handleLogoutClick = () => {
    closeAccountMenu();
    logout();
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {userStore.isManager ? (
        <Tooltip title="설정">
          <IconButton onClick={goToSetting} size="small" color="inherit">
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
      <Tooltip title="계정">
        <IconButton onClick={openAccountMenu} size="small" color="inherit">
          <PersonIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={isDarkMode ? '라이트 모드' : '다크 모드'}>
        <IconButton onClick={toggleTheme} size="small" color="inherit">
          {isDarkMode ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <AccountMenu
        anchorEl={accountMenuAnchorEl}
        open={accountMenuOpen}
        onClose={closeAccountMenu}
        onLogout={handleLogoutClick}
      />
    </Stack>
  );
});

export default NavbarPersonal;
